
  import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component({
    components: {},
  })
  export default class ReadMore extends Vue {
    @Prop({ required: true }) readonly value!: boolean;
  }
